/**
 *
 * List of Campaigns Only
 */
import { Container, Divider, Grid, Typography } from '@mui/material';
import { useQuery } from '@apollo/client';

import LoadingError from '../Layout/LoadingError';
import Loading from '../Layout/Loading';
import { useState } from 'react';
import { LIST_ORGANIZATIONS } from './organization.queries';
import { Organization } from './organization.model';
import PaginationButtons from '../Funds/components/PaginationButtons';
import OrganizationListItem from './OrganizationListItem';

export default function OrganizationList() {
  const [page, setPage] = useState(0);

  const { loading, error, data, fetchMore } = useQuery(LIST_ORGANIZATIONS, {
    variables: { page },
  });

  function loadMore() {
    const nextPage = page + 1;
    fetchMore({ variables: { page: nextPage } });
    setPage(page + 1);
  }

  if (loading) return <Loading />;
  if (error) return <LoadingError />;

  const organizations = data.organizationsPublic?.organizations ?? [];

  return (
    <Container sx={{ pt: 4 }}>
      <Grid container sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Typography
            sx={{ mb: 2 }}
            color="primary"
            variant="h5"
            component="h1"
          >
            Organizations
          </Typography>
          <Typography paragraph variant="body1">
            Browse the organzations below to learn more about the work they are
            doing, and see how you can make a direct impact with their current
            campaigns.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>

      <Grid container spacing={4}>
        {organizations.map((organization: Organization, index: number) => {
          return (
            <Grid key={index} item xs={12} sm={12} md={4}>
              <OrganizationListItem organization={organization} />
            </Grid>
          );
        })}
        {organizations.length < 1 ? (
          <Grid item xs={12} sx={{ mt: 1 }}>
            <Typography>
              No campaigns currently running. Check back later, or sign up to
              start one.
            </Typography>
          </Grid>
        ) : (
          <div></div>
        )}
      </Grid>
      <PaginationButtons
        loadMore={loadMore}
        hasMore={data.organizations?.hasMore}
        sx={{ mt: 2 }}
      />
    </Container>
  );
}
